"use client";

import React from "react";

export default function Heading({ children, className }: { children: React.ReactNode, className?: string }) {
    return (
        <h2 className={`text-5xl md:text-8xl xl:text-9xl font-nebulica font-semibold lg:font-extrabold mb-6 ${className}`}>
            {children}
        </h2>
    );
}